export default (el, binding) => (el.indeterminate = binding.value)
